module.exports = __webpack_public_path__ + "a8a45623d57bc523be149a69e84d327a.svg";